import { ActionControllerEventName, ResourcesManager, ResourceType, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { deepClone } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/DeepClone';
import { MaterialImprovement } from '../../../utils/MaterialImprovement';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from '../../../utils/PreparationPickingObjects';
export class TestTube extends ViewerModule {
    constructor(level) {
        super();
        this.level = level;
        this.addedWater = false;
        this.addedColoring = false;
        this.dropsQuantity = 0;
        this.coloringDropsQuantity = 0;
        this.resourcesInUse.push({
            name: 'test_tube_empty',
            type: ResourceType.FBX_MODEL,
            priority: 0,
            url: require('../../../../assets/models/spectrophotometer/test_tube_empty.fbx')
        }, {
            name: 'test_tube_red',
            type: ResourceType.FBX_MODEL,
            priority: 0,
            url: require('../../../../assets/models/spectrophotometer/test_tube_red.fbx')
        }, {
            name: 'test_tube_blue',
            type: ResourceType.FBX_MODEL,
            priority: 0,
            url: require('../../../../assets/models/spectrophotometer/test_tube_blue.fbx')
        });
    }
    init() {
        if (this.model)
            this.removeObject(this.model);
        this.addObject(this.model = deepClone(ResourcesManager.getModel('test_tube_blue').clone()));
        this.waterMesh = this.model.getObjectByName('polySurface24');
        this.waterMesh.scale.y = 0.001;
        MaterialImprovement.upgradeMaterialsFromModel(this.model, 'test_tube_blue');
        this.addedWater = false;
        this.addedColoring = false;
    }
    addWater() {
        if (this.addedWater)
            return;
        // this.removeObject(this.model);
        ResourcesManager.getAudioManger().getAudio('water_pouring_sound').play();
        this.waterMesh.scale.y = 1;
        // this.addObject(this.model = deepClone(ResourcesManager.getModel('test_tube_blue').clone()));
        // MaterialImprovement.upgradeMaterialsFromModel(this.model, 'test_tube_blue');
        this.addedWater = true;
    }
    addColor() {
        if (this.addedColoring)
            return;
        this.removeObject(this.model);
        ResourcesManager.getAudioManger().getAudio('water_pouring_sound').play();
        this.addObject(this.model = deepClone(ResourcesManager.getModel('test_tube_red').clone()));
        MaterialImprovement.upgradeMaterialsFromModel(this.model, 'test_tube_red');
        // this.waterMesh = <Mesh>this.model.getObjectByName('polySurface24');
        // this.waterMesh.scale.y = 0.001;
        this.addedColoring = true;
    }
    getDraggable(dragndropGroup) {
        this.draggable = dragndropGroup.addDraggable(this.uiObject);
        this.draggable.canBeDragged = false;
        return this.draggable;
    }
    setDraggable(value) {
        if (!value)
            return;
        if (!Viewer.controls.zController) {
            this.actionController.once(ActionControllerEventName.click, this.model, () => {
                Viewer.pointerController.setObject(this.model);
                this.fire('took');
            });
        }
        else {
            if (!this.model.userData.prevPosition)
                PreparationPickingObjects.saveObjectState(this.model);
            PreparationPickingObjects.saveObjectState(this.model);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.model, () => {
                if (!this.level.interaction)
                    return;
                Viewer.scene.add(this.model);
                this.model.traverse(el => {
                    el.userData.oldRaycast = el.raycast;
                    el.raycast = () => { };
                });
                this.fire('took');
            });
        }
    }
    reset() {
        this.actionController &&
            this.actionController.off(null, this.model);
        this.actionController &&
            this.actionController.off(null, this.uiObject);
        this.level.lobby.app.zSpacePickingController &&
            this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.model);
        this.init();
        this.dropsQuantity = 0;
        this.coloringDropsQuantity = 0;
    }
    addDrop(quantity) {
        this.dropsQuantity++;
        if (this.dropsQuantity >= 100) {
            this.fire('drop_filled');
        }
        else {
            this.waterMesh.scale.y = this.dropsQuantity / 100;
        }
    }
    addColoringDrop(quantity) {
        this.coloringDropsQuantity++;
        if (this.coloringDropsQuantity >= 1) {
            this.fire('coloring_drop_filled');
        }
    }
}
